"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandType = void 0;
var CommandType;
(function (CommandType) {
    CommandType["CIRCUIT_STATE"] = "circuit_state";
    CommandType["MODE"] = "mode";
    CommandType["ACK_ALARM"] = "acknowledge_alarm";
    CommandType["DOWNLOAD_CONFIG"] = "download_config";
    CommandType["APPLY_CONFIG"] = "apply_config";
    CommandType["DOWNLOAD_FIRMWARE"] = "download_firmware";
    CommandType["APPLY_FIRMWARE"] = "apply_firmware";
    CommandType["RESTART"] = "restart";
    CommandType["REFRESH"] = "refresh";
    CommandType["UPDATE_SCHEDULE"] = "update_schedule";
    CommandType["UPDATE_LOCATION"] = "update_location";
    CommandType["APPLY_RELEASE"] = "apply_release";
    CommandType["DOWNLOAD_RELEASE"] = "download_release";
    CommandType["GET_ALL_VEHICLE_STATUSES"] = "get_all_vehicle_statuses";
    CommandType["RESET_STATUS"] = "reset_status";
    CommandType["ACKNOWLEDGE_STATUS"] = "ack_status";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
//# sourceMappingURL=CommandType.js.map